export enum LayoutUnitTypeEnum {
  livingUnit = 0,
  serviceUnit = 1,
  businessUnit = 2,
  empty = 3,
  minusOne = 4,
}
